import { initI18n } from '@wix/wix-i18n-config';
import { createHttpClient } from '@wix/http-client';
import { calculateAppEnvironment, createHub } from '@wix/error-monitor';
import Experiments, { ReadOnlyExperiments } from '@wix/wix-experiments';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import { factory as webBiLoggerFactory } from '@wix/web-bi-logger';
import * as Sentry from '@sentry/browser';
import { EssentialsPartialGetters } from './EssentialsPartialGetters';
import { DataCapsule, LocalStorageCachedCapsule, LocalStorageStrategy, WixStorageStrategy, } from '@wix/data-capsule';
import { createCurrencyFormatterWithDefaults, formatAddress } from '@wix/l10n';
export class EssentialsPartialDelegate extends EssentialsPartialGetters {
    constructor({ experiments: experimentsOptions, fedops: fedopsOptions, errorMonitor: errorMonitorOptions, httpClient: httpClientOptions = {}, i18n: i18nOptions, dataCapsule: dataCapsuleOptions, parent, }) {
        super();
        this.httpClient = httpClientOptions
            ? createHttpClient(httpClientOptions)
            : null;
        this.dataCapsule = dataCapsuleOptions
            ? new DataCapsule(Object.assign(Object.assign({}, dataCapsuleOptions), { strategy: dataCapsuleOptions.storageStrategy === 'userPreferences' &&
                    this.httpClient
                    ? LocalStorageCachedCapsule({
                        remoteStrategy: new WixStorageStrategy({
                            httpClient: this.httpClient,
                        }),
                    })
                    : new LocalStorageStrategy() }))
            : null;
        this.experiments = experimentsOptions
            ? 'scopes' in experimentsOptions
                ? new Experiments({ scopes: experimentsOptions.scopes })
                : new ReadOnlyExperiments({ experiments: experimentsOptions.bag })
            : null;
        this.fedopsLogger = fedopsOptions
            ? createFedopsLogger(fedopsOptions.appName)
            : null;
        this.errorMonitor = errorMonitorOptions
            ? createHub(Object.assign({ Sentry, environment: calculateAppEnvironment() }, errorMonitorOptions))
            : null;
        const environment = this.getEnvironment(parent);
        this.i18n = i18nOptions
            ? initI18n(Object.assign({ locale: environment.language }, i18nOptions))
            : null;
        this.biLoggerFactory = webBiLoggerFactory;
        this.biLogger = this.biLoggerFactory().logger();
        this.createCurrencyFormatter = createCurrencyFormatterWithDefaults({
            language: environment.language,
        });
        this.formatAddress = formatAddress;
    }
}
//# sourceMappingURL=EssentialsPartialDelegate.js.map